import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'

import { LANGUAGES } from '../config/constants'
import de from '../locales/de.json'
import en from '../locales/en.json'
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
  },
  lng: LANGUAGES.ENGLISH,
  fallbackLng: LANGUAGES.ENGLISH,
  interpolation: { escapeValue: false },
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
  },
})

export default i18n
